import { displayFontFamily } from "styles/theme";

import { g } from "../../Gamification/components/shared/tokens";

const styles = {
  header: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: "16px",
    flexWrap: "wrap",
    mb: "16px",
  },
  titleGroup: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    minWidth: 0,
  },
  iconBox: {
    width: 44,
    height: 44,
    borderRadius: "12px",
    display: "grid",
    placeItems: "center",
    flexShrink: 0,
    background: g.primaryTint,
    color: g.primary,
  },
  title: {
    fontFamily: displayFontFamily,
    fontSize: 19,
    fontWeight: 600,
    letterSpacing: "-0.4px",
    lineHeight: 1.2,
    color: g.text,
  },
  subtitle: {
    fontSize: 13.5,
    lineHeight: 1.45,
    color: g.text2,
    mt: "2px",
  },
  chipSlot: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexShrink: 0,
  },
};

export default styles;
